import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
    selector: 'app-back-to-season-manager',
    templateUrl: './back-to-season-manager.component.html',
    styleUrls: ['./back-to-season-manager.component.css'],
    standalone: false
})
export class BackToSeasonManagerComponent implements OnInit {

  isFieldLink: boolean = false;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private router: Router,
    public matDialogRef: MatDialogRef<BackToSeasonManagerComponent>,
  ){

  }
  ngOnInit(): void {
    this.isFieldLink = this.data?.isFieldLink;
  }

  cancel(): void {
    this.matDialogRef.close({"option": "cancel"});
  }

  back(): void {
    this.matDialogRef.close({"option": "back"});
    if(this.isFieldLink){
      this.router.navigate(['/season-manager/fields']);
    }


}
}
